const getSound = async (letter, level = 1) => {
  const sound = await import(`../assets/sounds/${letter}_${level}.mp3`);
  return sound.default;
};

// Level 1 is Phase 2
// Level 2 is Phase 3
// There is no Phase 4 on the .docx file
// Level 3 is Phase 5
const phonics = {
  levelOne: {
    s: {
      phonics: "s",
      text: "as in 'sat'",
      sound: () => getSound("s", 1),
    },
    a: {
      phonics: "a",
      text: "as in 'ant'",
      sound: () => getSound("a", 1),
    },
    t: {
      phonics: "t",
      text: "as in 'tap'",
      sound: () => getSound("t", 1),
    },
    p: {
      phonics: "p",
      text: "as in 'pat'",
      sound: () => getSound("p", 1),
    },
    i: {
      phonics: "i",
      text: "as in 'ink'",
      sound: () => getSound("i", 1),
    },
    n: {
      phonics: "n",
      text: "as in 'nap'",
      sound: () => getSound("n", 1),
    },
    m: {
      phonics: "m",
      text: "as in 'mud'",
      sound: () => getSound("m", 1),
    },
    d: {
      phonics: "d",
      text: "as in 'dog'",
      sound: () => getSound("d", 1),
    },
    g: {
      phonics: "g",
      text: "as in 'gap'",
      sound: () => getSound("g", 1),
    },
    o: {
      phonics: "s",
      text: "as in 'on'",
      sound: () => getSound("o", 1),
    },
    c: {
      phonics: "c",
      text: "as in 'cat'",
      sound: () => getSound("c", 1),
    },
    k: {
      phonics: "k",
      text: "as in 'kit'",
      sound: () => getSound("k", 1),
    },
    ck: {
      phonics: "ck",
      text: "as in 'pick'",
      sound: () => getSound("ck", 1),
    },
    u: {
      phonics: "u",
      text: "as in 'up'",
      sound: () => getSound("u", 1),
    },
    e: {
      phonics: "e",
      text: "as in 'egg'",
      sound: () => getSound("e", 1),
    },
    r: {
      phonics: "r",
      text: "as in 'rat'",
      sound: () => getSound("r", 1),
    },
    h: {
      phonics: "h",
      text: "as in 'hot'",
      sound: () => getSound("h", 1),
    },
    b: {
      phonics: "b",
      text: "as in 'big'",
      sound: () => getSound("b", 1),
    },
    f: {
      phonics: "f",
      text: "as in 'fox'",
      sound: () => getSound("f", 1),
    },
    ff: {
      phonics: "ff",
      text: "as in 'puff'",
      sound: () => getSound("ff", 1),
    },
    l: {
      phonics: "l",
      text: "as in 'lid'",
      sound: () => getSound("l", 1),
    },
    ll: {
      phonics: "ll",
      text: "as in 'bell'",
      sound: () => getSound("ll", 1),
    },
    ss: {
      phonics: "ss",
      text: "as in 'dress'",
      sound: () => getSound("ss", 1),
    },
  },
  levelTwo: {
    j: {
      phonics: "j",
      text: "as in jug",
      sound: () => getSound("j", 1),
    },
    v: {
      phonics: "v",
      text: "as in van",
      sound: () => getSound("v", 1),
    },
    x: {
      phonics: "x",
      text: "as in fox",
      sound: () => getSound("x", 1),
    },
    w: {
      phonics: "w",
      text: "as in web",
      sound: () => getSound("w", 1),
    },
    y: {
      phonics: "y",
      text: "as in yellow",
      sound: () => getSound("y", 1),
    },
    z: {
      phonics: "z",
      text: "as in zebra",
      sound: () => getSound("z", 1),
    },
    zz: {
      phonics: "zz",
      text: "as in fizzy",
      sound: () => getSound("zz", 1),
    },
    qu: {
      phonics: "qu",
      text: "as in queen",
      sound: () => getSound("qu", 1),
    },
    ch: {
      phonics: "ch",
      text: "as in chick",
      sound: () => getSound("ch", 1),
    },
    sh: {
      phonics: "sh",
      text: "as in sheep",
      sound: () => getSound("sh", 1),
    },
    th: {
      phonics: "th",
      text: "as in thumb",
      sound: () => getSound("th", 1),
    },
    ng: {
      phonics: "ng",
      text: "as in ring",
      sound: () => getSound("ng", 1),
    },
    ai: {
      phonics: "ai",
      text: "as in train",
      sound: () => getSound("ai", 1),
    },
    ee: {
      phonics: "ee",
      text: "as in bee",
      sound: () => getSound("ee", 1),
    },
    igh: {
      phonics: "igh",
      text: "as in light",
      sound: () => getSound("igh", 1),
    },
    oa: {
      phonics: "oa",
      text: "as in boat",
      sound: () => getSound("oa", 1),
    },
    oo: {
      phonics: "oo",
      text: "as in moon",
      sound: () => getSound("oo", 1),
    },
    ar: {
      phonics: "ar",
      text: "as in car",
      sound: () => getSound("ar", 1),
    },
    or: {
      phonics: "or",
      text: "as in fork",
      sound: () => getSound("or", 1),
    },
    ur: {
      phonics: "ur",
      text: "as in purse",
      sound: () => getSound("ur", 1),
    },
    ow: {
      phonics: "ow",
      text: "as in owl",
      sound: () => getSound("ow", 1),
    },
    oi: {
      phonics: "oi",
      text: "as in coin",
      sound: () => getSound("oi", 1),
    },
    ear: {
      phonics: "ear",
      text: "as in ear",
      sound: () => getSound("ear", 1),
    },
    air: {
      phonics: "air",
      text: "as in chair",
      sound: () => getSound("air", 1),
    },
    ure: {
      phonics: "ure",
      text: "as in manure",
      sound: () => getSound("ure", 1),
    },
    er: {
      phonics: "er",
      text: "as in hammer",
      sound: () => getSound("er", 1),
    },
  },
  levelThree: {
    ay: {
      phonics: "ay",
      text: "as in crayon",
      sound: () => getSound("ay", 1),
    },
    "a-e": {
      phonics: "a-e",
      text: "as in cake",
      sound: () => getSound("a-e", 1),
    },
    er: {
      phonics: "er",
      text: "as in herbs",
      sound: () => getSound("er", 1),
    },
    ir: {
      phonics: "ir",
      text: "as in bird",
      sound: () => getSound("ir", 1),
    },
    "e-e": {
      phonics: "e-e",
      text: "as in scene",
      sound: () => getSound("e-e", 1),
    },
    ea: {
      phonics: "ea",
      text: "as in peach",
      sound: () => getSound("ea", 1),
    },
    ey: {
      phonics: "ey",
      text: "as in key",
      sound: () => getSound("ey", 1),
    },
    ou: {
      phonics: "ou",
      text: "as in cloud",
      sound: () => getSound("ou", 1),
    },
    "i-e": {
      phonics: "i-e",
      text: "as in time",
      sound: () => getSound("i-e", 1),
    },
    ie: {
      phonics: "ie",
      text: "as in pie",
      sound: () => getSound("ie", 1),
    },
    oy: {
      phonics: "oy",
      text: "as in toy",
      sound: () => getSound("oy", 1),
    },
    au: {
      phonics: "au",
      text: "as in astronaut",
      sound: () => getSound("au", 1),
    },
    aw: {
      phonics: "aw",
      text: "as in strawberry",
      sound: () => getSound("aw", 1),
    },
    "o-e": {
      phonics: "o-e",
      text: "as in rope",
      sound: () => getSound("o-e", 1),
    },
    ow: {
      phonics: "ow",
      text: "as in snow",
      sound: () => getSound("ow", 1),
    },
    oe: {
      phonics: "oe",
      text: "as in toe",
      sound: () => getSound("oe", 1),
    },
    wh: {
      phonics: "wh",
      text: "as in wheel",
      sound: () => getSound("wh", 1),
    },
    "u-e": {
      phonics: "u-e",
      text: "as in cube",
      sound: () => getSound("u-e", 1),
    },
    ue: {
      phonics: "ue",
      text: "as in blue",
      sound: () => getSound("ue", 1),
    },
    ew: {
      phonics: "ew",
      text: "as in news",
      sound: () => getSound("ew", 1),
    },
    ph: {
      phonics: "ph",
      text: "as in dolphin",
      sound: () => getSound("ph", 1),
    },
  },
};

export default phonics;
